import { render, staticRenderFns } from "./CallsView.vue?vue&type=template&id=e881755e&scoped=true&"
import script from "./CallsView.vue?vue&type=script&lang=ts&"
export * from "./CallsView.vue?vue&type=script&lang=ts&"
import style0 from "./CallsView.vue?vue&type=style&index=0&id=e881755e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e881755e",
  null
  
)

export default component.exports